/** @jsxImportSource @emotion/react */
import PropTypes from "prop-types";
import { ReactComponent as ArrowRightIcon } from "assets/icons/Arrow-Right.svg";
import { ReactComponent as ArrowForwardIcon } from "assets/icons/ArrowForward.svg";
import { buttonCss } from "./index.css";

const ICONS = {
  standard: <ArrowRightIcon />,
  forward: <ArrowForwardIcon />,
};

export default function ArrowButton({ disabled, direction, arrowType, onClick }) {
  return (
    <button type="button" css={buttonCss({ direction })} onClick={onClick} disabled={disabled}>
      {ICONS[arrowType] ?? "?"}
    </button>
  );
}

ArrowButton.propTypes = {
  disabled: PropTypes.bool.isRequired,
  direction: PropTypes.oneOf(["left", "right"]).isRequired,
  arrowType: PropTypes.oneOf(["standard", "forward"]).isRequired,
  onClick: PropTypes.func.isRequired,
};
